import './ProgressIndicator.sass';

import UntitledIcon from '@payaca/untitled-icons';

type Props = {
  className?: string;
};
const ProgressIndicator = ({ className }: Props) => {
  return (
    <UntitledIcon
      className={`progress-indicator${className ? ` ${className}` : ''}`}
      name="circle.4"
    />
  );
};

export default ProgressIndicator;
